import cn from "classnames";
import { useTranslation } from "react-i18next";

import { TicketStatus } from "../../aiTickets.types";

import styles from "./StatusPill.module.scss";

interface Props {
  status: TicketStatus;
  withChevron?: boolean;
}

const Chevron = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M3 4.5L6 7.5L9 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StatusPill = ({ status, withChevron = true }: Props) => {
  const { t } = useTranslation();
  return (
    <span
      className={cn(styles.pill, {
        [styles.pillOpen]: status === "Open",
        [styles.pillProcessing]: status === "Processing",
        [styles.pillResolved]: status === "Resolved",
        [styles.pillClosed]: status === "Closed",
      })}
    >
      {t(status)}
      {withChevron && <Chevron />}
    </span>
  );
};

export default StatusPill;
